"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionWatcherContextProvider = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react")); // CONTEXT


var SessionWatcherContext = (0, react_1.createContext)({}); // PROVIDER

var SessionWatcherContextProvider = function SessionWatcherContextProvider(_ref) {
  var children = _ref.children,
      settings = _ref.settings,
      ignoreCleanUp = _ref.ignoreCleanUp;

  // once we have left the flow indicated by the path, we clean up the sessionStorage
  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      trigger = _react_1$default$useS2[0],
      setTrigger = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      hasMounted = _react_1$default$useS4[0],
      setHasMounted = _react_1$default$useS4[1];

  var currentPage = react_1.default.useRef("");
  var sessionWatcherSettings = react_1.default.useRef([]);
  /**
   *
   * @param sessionKeySubstring
   */

  var cleanUpKeys = function cleanUpKeys(sessionKeySubstring) {
    var sessionItems = Object.keys(sessionStorage);
    sessionItems.forEach(function (sessionItem) {
      if (Array.isArray(sessionKeySubstring)) {
        var foundKeys = sessionKeySubstring.some(function (key) {
          return sessionItem.includes(key);
        });
        foundKeys && sessionStorage.removeItem(sessionItem);
      } else if (sessionItem.includes(sessionKeySubstring)) {
        sessionStorage.removeItem(sessionItem);
      }
    });
  };

  (0, react_1.useEffect)(function () {
    sessionWatcherSettings.current = settings; // Pops State handling (back button and forward button)

    var handlePopState = function handlePopState(event) {
      //eslint-disable-next-line
      if (typeof window !== "undefined") {
        if (currentPage.current !== window.location.pathname) {
          currentPage.current = window.location.pathname;
          setTrigger(function (prev) {
            return !prev;
          });
        }
      }
    }; // Pop State Event


    window === null || window === void 0 ? void 0 : window.addEventListener("popstate", handlePopState); // Wrap Push State Events to trigger state change

    (function (history) {
      if (typeof window !== "undefined") {
        var pushState = history.pushState;

        history.pushState = function () {
          for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
            rest[_key] = arguments[_key];
          }

          var url = rest[2];

          if (typeof url === "object" && Object.getPrototypeOf(url) === URL.prototype) {
            currentPage.current = (url === null || url === void 0 ? void 0 : url.pathname) || "";
          } else {
            currentPage.current = url;
          }

          currentPage.current !== window.location.pathname && setTrigger(function (prev) {
            return !prev;
          });
          return pushState.apply(history, rest);
        };
      }
    })(window === null || window === void 0 ? void 0 : window.history);

    setHasMounted(true);
    return function () {
      window === null || window === void 0 ? void 0 : window.removeEventListener("popstate", handlePopState);
    };
  }, []); // Watch for changes in the path and clean up session storage keys if needed

  (0, react_1.useEffect)(function () {
    var currentPath = (window === null || window === void 0 ? void 0 : window.location.pathname) || "";
    sessionWatcherSettings.current.forEach(function (pathItem) {
      var inPath = false;

      if (Array.isArray(pathItem.pathName)) {
        // check array if any of the path names are in the current path and is so break out of array
        inPath = pathItem.pathName.some(function (pathName) {
          return currentPath.includes(pathName);
        });
      } else {
        inPath = currentPath.includes(pathItem.pathName);
      }

      var hasLeftPath = !inPath;
      var shouldClean = pathItem.shouldCleanAll;

      if (hasLeftPath && shouldClean && !ignoreCleanUp) {
        pathItem.shouldCleanAll = false;
        cleanUpKeys(pathItem.sessionKeySubstring);
      } else if (inPath) {
        pathItem.shouldCleanAll = true;
      }
    });
  }, [trigger]);
  var app = {};
  var exposed = Object.assign({}, app);
  return (0, jsx_runtime_1.jsx)(SessionWatcherContext.Provider, {
    value: exposed,
    children: children
  });
};

exports.SessionWatcherContextProvider = SessionWatcherContextProvider;
exports.default = SessionWatcherContext;